<template>
  <footer
    class="
      bg-gray-700
      flex flex-col
      fixed
      md:absolute
      top-0
      right-0
      w-full
      h-full
      z-50
      p-8
      justify-between
    "
    :class="{ hidden: !isFooterOpen }"
  >
    <div class="absolute top-9 right-9 cursor-pointer" @click="close">
      <Icon id="close" color="#fff" />
    </div>
    <div v-if="authUserName" class="mt-28 text-center">
      <img
        v-if="authImageUrl"
        :src="authImageUrl"
        alt="profile"
        class="rounded-full w-28 h-28 lg:w-40 lg:h-40 mx-auto mb-6"
      />
      <div class="text-xs tracking-widest text-gray-300 mb-2">
        {{ $t("footerLoggedIn") }}
      </div>
      <div class="text-base tracking-widest text-white mb-6">
        {{ authUserName }}
      </div>
      <div
        class="
          border-2 border-white
          rounded
          text-white
          mb-8
          py-2
          px-6
          text-sm
          font-semibold
          w-min
          mx-auto
          cursor-pointer
        "
        @click="logout"
      >
        {{ $t("footerLogout") }}
      </div>
    </div>
    <ul class="text-white text-lg tracking-widest mb-4" v-if="$tLocales.length">
      <li class="mb-4">
        <div class="flex justify-center">
          <div
            v-for="(locale, index) in $tLocales"
            :key="locale"
            class="flex cursor-pointer"
            @click="$emit('onLocale', locale)"
          >
            {{ locale }}
            <i
              class="h-full w-px bg-white block mx-3"
              v-if="index !== $tLocales.length - 1"
            ></i>
          </div>
        </div>
      </li>
    </ul>
    <div>
      <ul class="text-gray-300 text-base tracking-widest mb-8">
        <li class="mb-4" @click="close">
          <span class="cursor-pointer" @click="onOnboarding">
            {{ $t("footerOnboardingTitle") }}
          </span>
          <!-- <router-link to="onboarding">
            {{ $t("footerOnboardingTitle") }}
          </router-link> -->
        </li>
        <li class="mb-4">
          <a
            :href="$t('footerLinkUrl1')"
            @click="onLink($t('footerLinkUrl1'))"
            target="_blank"
          >
            {{ $t("footerLinkTitle1") }}
          </a>
        </li>
        <li class="mb-4">
          <a
            :href="$t('footerLinkUrl2')"
            @click="onLink($t('footerLinkUrl2'))"
            target="_blank"
          >
            {{ $t("footerLinkTitle2") }}
          </a>
        </li>
        <li class="mb-4">
          <a
            :href="$t('footerLinkUrl3')"
            @click="onLink($t('footerLinkUrl3'))"
            target="_blank"
          >
            {{ $t("footerLinkTitle3") }}
          </a>
        </li>
      </ul>
      <span class="text-xs text-gray-300">{{ $t("footerCopy") }}</span>
    </div>
  </footer>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { Mixins, Component, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'
import cms from '../../cms'

@Component({
})
export default class Footer extends Mixins(TranslationHandler) {
  @Getter isFooterOpen!: boolean
  @Getter authUserName!: string
  @Getter authImageUrl!: string

  @Getter storageKeyPage!: string

  @Mutation('SET_IS_FOOTER_OPPEN') setIsFooterOpen!: (val: boolean) => void

  @Action('AUTH_LOGOUT') authLogout!: () => void

  @Watch('isFooterOpen')
  wathIsFooterOpen (val: boolean) {
    if (val === true) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }

  logout () {
    this.authLogout()
    this.$router.push('/')
  }

  onLink (url: string) {
    cms.tracking.trackNavigation('navigation', { navigation_item: url })
  }

  close () {
    this.setIsFooterOpen(false)
  }

  onOnboarding () {
    // cms.tracking.trackNavigation('Footer', 'Onboarding', 'navigation', { navigation_item: 'Onboarding' })
    localStorage.setItem(this.storageKeyPage, this.$route.path)
    this.$router.push('/onboarding')
  }
}
</script>
